import rootedLogo from '../../assets/rooted-logo.jpg';

// `variant`/`opacity` props are accepted for backwards compatibility with
// existing call sites but no longer change rendering — the new Rooted mark
// is shipped as a circle-cropped photographic logo.
export default function FoxMark({
  size = 40,
  style = {},
  // eslint-disable-next-line no-unused-vars
  variant = 'default',
  // eslint-disable-next-line no-unused-vars
  opacity,
  // eslint-disable-next-line no-unused-vars
  className,
}) {
  return (
    <div
      style={{
        width: size,
        height: size,
        borderRadius: '50%',
        overflow: 'hidden',
        flexShrink: 0,
        ...style,
      }}
    >
      <img
        src={rootedLogo}
        alt="Rooted"
        style={{
          width: '100%',
          height: '100%',
          objectFit: 'cover',
        }}
      />
    </div>
  );
}
